import { render, staticRenderFns } from "./MessagesContactPreview.vue?vue&type=template&id=604a74c0&scoped=true&"
import script from "./MessagesContactPreview.vue?vue&type=script&lang=js&"
export * from "./MessagesContactPreview.vue?vue&type=script&lang=js&"
import style0 from "./MessagesContactPreview.vue?vue&type=style&index=0&id=604a74c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a74c0",
  null
  
)

export default component.exports